











import { defineComponent, computed } from '@vue/composition-api';
import { ParagraphSize } from '@getaccept/lib-ui';
import { DateHelper } from '@getaccept/lib-shared/src/helpers/date.helper';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import { DateTime } from 'luxon';

export default defineComponent({
  name: 'DateCell',
  props: {
    date: {
      type: String,
      default: '',
    },
    userName: {
      type: String,
      default: '',
    },
    hidden: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const formattedDate = computed(() => {
      if (!props.date) {
        return '';
      }
      const isoDate = DateTime.fromISO(props.date);

      if (DateHelper.isToday(isoDate)) {
        return t('Today').toString();
      }
      if (DateHelper.isYesterday(isoDate)) {
        return t('Yesterday').toString();
      }

      return isoDate.toLocaleString({ ...DateTime.DATE_FULL });
    });

    return {
      ParagraphSize,
      formattedDate,
    };
  },
});
